var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-flash',{attrs:{"details":""}}),_c('v-container',{staticClass:"app--full-height",attrs:{"fluid":""}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }